import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

/**
 * Authentication Service
 * Handles all authentication-related API calls
 */

export const authService = {
  /**
   * Login user
   * @param {string} username - Username
   * @param {string} password - Password
   * @returns {Promise} Auth token and user data
   */
  login: async (username, password) => {
    try {
      const response = await apiClient.post(ENDPOINTS.AUTH.LOGIN, {
        username,
        password,
      });

      // Store token in localStorage
      if (response.token) {
        localStorage.setItem('authToken', response.token);
      }

      return response;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },

  /**
   * Logout user
   * @returns {Promise} Logout confirmation
   */
  logout: async () => {
    try {
      await apiClient.post(ENDPOINTS.AUTH.LOGOUT);
      localStorage.removeItem('authToken');
    } catch (error) {
      console.error('Logout failed:', error);
      // Remove token anyway
      localStorage.removeItem('authToken');
      throw error;
    }
  },

  /**
   * Refresh authentication token
   * @returns {Promise} New token
   */
  refreshToken: async () => {
    try {
      const response = await apiClient.post(ENDPOINTS.AUTH.REFRESH);

      if (response.token) {
        localStorage.setItem('authToken', response.token);
      }

      return response;
    } catch (error) {
      console.error('Token refresh failed:', error);
      throw error;
    }
  },

  /**
   * Verify current token
   * @returns {Promise} Token validity and user data
   */
  verifyToken: async () => {
    try {
      const response = await apiClient.get(ENDPOINTS.AUTH.VERIFY);
      return response;
    } catch (error) {
      console.error('Token verification failed:', error);
      throw error;
    }
  },

  /**
   * Get current auth token
   * @returns {string|null} Auth token
   */
  getToken: () => {
    return localStorage.getItem('authToken');
  },

  /**
   * Check if user is authenticated
   * @returns {boolean} Authentication status
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');
  },



  // Change password (regular flow)
 
  changePassword: async ({ username, oldPassword, newPassword }) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.AUTH.CHANGE_PASSWORD,
        {
          username,
          oldPassword,
          newPassword,
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to change password:', error);
      throw error;
    }
  },


  //Change password (first-time login)

  changePasswordFirstTime: async ({ username, oldPassword, newPassword }) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.AUTH.CHANGE_PASSWORD_FIRST_TIME,
        {
          username,
          oldPassword,
          newPassword,
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to change password (first time):', error);
      throw error;
    }
  },

};

export default authService;
